import { useRecalProposalSetVM } from "presentation/hook/RecalProposalSet/useRecalProposalSetVM";
import { useRecalProposalSetTracked } from "presentation/store/RecalProposalSet/RecalProposalSetProvider";
import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import RecalProposalSetEditPanel from "./RightPanel/RecalProposalSetEditPanel";
import RecalProposalSetDtlTablePanel from "./Table/RecalProposalSetDtlTablePanel";
import RecalProposalSetTablePanel from "./Table/RecalProposalSetTablePanel";


const RecalProposalSetMaintenance: React.FC = () => {
    const [recalProposalSetState] = useRecalProposalSetTracked();
    const [isLoading, setIsLoading] = useState(true);
    const recalProposalSetVM = useRecalProposalSetVM();
    const { isShowEditPanel } = recalProposalSetState;


    useEffect(() => {
        const initialScreen = async () => {
            try {
                const results = await Promise.allSettled([
                    recalProposalSetVM.loadDropdownOption(),
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {

                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then((data) => {
            recalProposalSetVM.searchAllRecalProposalSetList().then((data) => {
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
            });
        }).catch(error => {
            setIsLoading(false)
        });

    }, [recalProposalSetVM])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper`}>

            {!(isShowEditPanel) && <>
                <RecalProposalSetTablePanel /></>}
            {(isShowEditPanel) && <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={"30%"}
                rightSectionWidth={"70%"}
                leftChildren={<RecalProposalSetEditPanel recalProposalSetState={recalProposalSetState} />}
                rightChildren={<RecalProposalSetDtlTablePanel recalProposalSetState={recalProposalSetState} />}
            />}
        </div>
    </>
}

export default memo(RecalProposalSetMaintenance);